<template>
    <form v-if="form">
        <id-data :id.sync="form.id" v-if="form.id"/>

        <personal-data :salutations="salutations"
                       :person.sync="form.person"
                       v-if="form.person"/>

        <address-data :address.sync="form.address"
                      :shop="isShopOwner"
                      v-if="form.address"/>

        <contact-data :contact.sync="form.contact"
                      v-if="form.contact"/>

        <password-data :pass.sync="form.pass"
                       v-if="form.pass"/>

        <div class="row">
            <div class="col-12">
                <button type="button" class="btn btn-cph-primary" name="save"
                        @click="saveForm" :disabled="$v.form.$invalid">
                    {{$t('UI.save')}}
                </button>
                <button type="button" class="btn btn-warning" name="cancel"
                        @click="$emit('cancel')">{{$t('UI.cancel')}}</button>
                <span v-if="errorMessage" class="error-msg">
                    {{errorMessage}}
                </span>
            </div>
        </div>

    </form>
</template>

<script type="text/babel">
import {email, minLength, numeric, required, sameAs} from 'vuelidate/lib/validators';
import PersonalData from './SubForms/PersonalData';
import AddressData from './SubForms/AddressData';
import ContactData from './SubForms/ContactData';
import {RegistrationPerimeter} from '../../../../../router/perimeters/registrationPerimeter';

import IdData from './SubForms/IdData';
import PasswordData from './PasswordData';

export default {
    name: 'Form',
    perimeters: [RegistrationPerimeter],
    data () {
        return {
            form: null,
            salutations: [
                'Ms',
                'Mrs',
                'Mr'
            ],
            errorMessage: '',
            forms: {
                [this.$TYPES.ROLES.ADMIN]: {
                    role: {
                        name: this.$TYPES.ROLES.ADMIN,
                        displayName: 'Admin'
                    },
                    id: '',
                    person: this.createPersonalDataForm(),
                    address: this.createCompanyAddressDataForm(),
                    contact: this.createContactDataForm(),
                    pass: this.createPassDataForm()
                },
                [this.$TYPES.ROLES.OPERATOR]: {
                    role: {
                        name: this.$TYPES.ROLES.OPERATOR,
                        displayName: 'Operator'
                    },
                    id: '',
                    person: this.createPersonalDataForm(),
                    contact: this.createContactDataForm(),
                    pass: this.createPassDataForm()
                },
                [this.$TYPES.ROLES.PARTNER]: {
                    role: {
                        name: this.$TYPES.ROLES.PARTNER,
                        displayName: 'Partner'
                    },
                    id: '',
                    address: this.createCompanyAddressDataForm(),
                    person: this.createPersonalDataForm(),
                    contact: this.createContactDataForm(),
                    pass: this.createPassDataForm()
                },
                [this.$TYPES.ROLES.KEY_ACCOUNT]: {
                    role: {
                        name: this.$TYPES.ROLES.KEY_ACCOUNT,
                        displayName: 'Key Account'
                    },
                    id: '',
                    address: this.createCompanyAddressDataForm(),
                    person: this.createPersonalDataForm(),
                    contact: this.createContactDataForm(),
                    pass: this.createPassDataForm()
                },
                [this.$TYPES.ROLES.SHOP_OWNER]: {
                    role: {
                        name: this.$TYPES.ROLES.SHOP_OWNER,
                        displayName: 'Shop Owner'
                    },
                    id: '',
                    address: this.createShopAddressDataForm(),
                    person: this.createPersonalDataForm(),
                    contact: this.createContactDataForm(),
                    pass: this.createPassDataForm()
                },
                [this.$TYPES.ROLES.SALES]: {
                    role: {
                        name: this.$TYPES.ROLES.SALES,
                        displayName: 'Sales'
                    },
                    id: '',
                    person: this.createPersonalDataForm(),
                    contact: this.createContactDataForm(),
                    pass: this.createPassDataForm()
                }
            }
        };
    },
    props: {
        editForm: {
            type: Object
        },
        role: {
            type: Object
        }
    },
    components: {
        PasswordData,
        ContactData,
        AddressData,
        PersonalData,
        IdData
    },
    computed : {
        isShopOwner () {
            return this.role.name === this.$TYPES.ROLES.SHOP_OWNER;
        }
    },
    watch: {
        role: {
            handler (newRole) {
                if(newRole) {
                    let copy = {...this.form};
                    let newForm = this.forms[newRole.name];
                    this.form = {};
                    for(let key in newForm) {
                        this.form[key] = newForm[key];
                        if(copy.hasOwnProperty(key)) {
                            this.form[key] = copy[key];
                        }
                    }
                    this.form.role = newRole;
                }
            },
            deep: true,
            immediate: true
        },
        editForm: {
            handler (newForm) {
                if(newForm) {
                    newForm.role = this.role;
                    if(!this.form) {
                        this.form = {};
                    }
                    this.form = Object.assign(this.form, newForm);
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        saveForm () {
            this.$emit('save', this.form);
        },
        createPersonalDataForm () {
            return {
                salutation: 'Mr.',
                firstName: '',
                lastName: ''
            };
        },
        createCompanyAddressDataForm () {
            return {
                companyName: '',
                street: '',
                streetNumber: '',
                postCode: '',
                city: '',
                country: ''
            };
        },
        createShopAddressDataForm () {
            return {
                shopName: '',
                street: '',
                streetNumber: '',
                postCode: '',
                city: '',
                country: ''
            };
        },
        createContactDataForm () {
            return {
                phone: '',
                mobilePhone: '',
                email: ''
            };
        },
        createPassDataForm () {
            return {
                password: '',
                repeatPassword: ''
            };
        }
    },
    validations: {
        form: {
            id: {

            },
            person: {
                salutation: {
                    required
                },
                firstName: {
                    required
                },
                lastName: {
                    required
                }
            },
            address () {
                if(!this.form.address) {
                    return {};
                }
                return {
                    [this.isShopOwner ? 'shopName': 'companyName'] : {
                        required,
                        minLength: minLength(1)
                    },
                    street: {
                        required
                    },
                    streetNumber: {
                        required
                    },
                    postCode: {
                        required
                    },
                    city: {
                        required
                    },
                    country: {
                        required
                    }
                };
            },
            contact () {
                if(!this.form.contact) {
                    return {};
                }
                return {
                    email: {
                        required,
                        email
                    },
                    phone: {
                        numeric
                    },
                    mobilePhone: {
                        numeric
                    }
                };
            }
            // pass: {
            //     password: {
            //         required,
            //         minLength: minLength(4)
            //     },
            //     repeatPassword: {
            //         sameAsPassword: sameAs('password')
            //     }
            // }
        }
    }

};

</script>

